import TOCSection from './TOCSection';

export default class UpdateTOCDraftRequest {
  public title = '';
  public structure: TOCSection[] = [];
}
